import { Box, Dialog, DialogContent } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { AsyncContent } from '~/components/AsyncContent';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { People } from '~/services/Http';

import { Announcement } from '../Announcement';

import { useContent } from './useContent';
import { useSxStyles } from './useStyles';

export interface Props {
  loading: boolean;
  failedToLoad: boolean;
  announcement?: People.CompanyPostDto;
  announcements: People.CompanyPostDto[];
  onReadMoreDialogOpen: () => void;
  onReadMoreDialogClose: () => void;
}

export const Content: React.FC<Props> = ({
  loading,
  failedToLoad,
  announcement,
  announcements,
  onReadMoreDialogOpen,
  onReadMoreDialogClose,
}) => {
  const ref = React.useRef<HTMLSpanElement>(null);
  const {
    fullAnnouncement,
    handleReadMoreButtonClick,
    handleAnnouncementDialogClose,
  } = useContent(
    onReadMoreDialogOpen,
    onReadMoreDialogClose,
    ref,
    announcements,
  );
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <>
      <Box component="span" ref={ref} sx={sxStyles.refDiv}>
        <AsyncContent
          isLoading={loading}
          failedToLoad={failedToLoad}
          noData={!announcements.length}
          noDataMessage={t('announcementsEmpty')}
          customSxStyles={{ root: sxStyles.root }}
        >
          {announcement && (
            <Announcement
              announcement={announcement}
              onReadMoreClick={handleReadMoreButtonClick}
            />
          )}
        </AsyncContent>
      </Box>

      <Dialog
        open={!!fullAnnouncement}
        onClose={handleAnnouncementDialogClose}
        data-cy="full-announcement-dialog"
      >
        <SolaForceDialogTitle onClose={handleAnnouncementDialogClose}>
          {t('announcements')}
        </SolaForceDialogTitle>
        <DialogContent sx={sxStyles.dialogContent}>
          {fullAnnouncement && <Announcement announcement={fullAnnouncement} />}
        </DialogContent>
      </Dialog>
    </>
  );
};
